import React, { Dispatch } from 'react';
import { BsStar } from 'react-icons/bs'
import { FiShare } from 'react-icons/fi';
import { ReactComponent as ReclusterIcon } from '../images/recluster.svg'
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentChannel, selectIsUserGuest } from '../store/selectors';
import { doChangeChannelRoute } from '../store/actions/channels';
import { doAddRemoveFavoriteCell } from '../store/actions/user';
import firebase from '../lib/firebase';
import classnames from 'classnames'

import styles from './Cell.module.scss';
import ChannelButton from '../Channel/ChannelButton';
import { isNative } from '../utils/utils';
import { doOpenModal } from '../store/actions/modal';
import { ModalType } from '../Modal/ModalTypes';

type CellMenuProps = {
  cellId: number,
  cellTitle: string,
  cellLayout: string,
  isFavorite: boolean,
  disableRecluster: boolean,
}

function shareCell(dispatch: Dispatch<any>, cellId: number, cellTitle: string, channelId: number) {
  const appUrl = process.env.REACT_APP_MODE === 'development' ? 'https://app-dev.clusterx.com/' : 'https://app.clusterx.com/';
  const cellUrl = appUrl + 'channel/' + channelId + '?pan=' + cellId;
  const message = "Check out \"" + cellTitle + "\" on ClusterX";

  if (isNative()) {
    import('@capacitor/core').then(capacitor => {
      capacitor.Share.share({
        title: "Shared from ClusterX",
        url: cellUrl,
        dialogTitle: "Share this Cell"
      });
    });
  // } else if (navigator.share) {
  //   navigator.share({
  //     title: "Shared from ClusterX",
  //     text: message,
  //     url: cellUrl,
  //   })
  //     .then(() => console.log('Successful share'))
  //     .catch((error) => console.log('Error sharing', error));
  } else {
    dispatch(doOpenModal({type: ModalType.ShareCell, cellId, cellTitle, cellUrl}))
  }
}

function CellMenu({cellId, cellTitle, isFavorite, disableRecluster}: CellMenuProps) {
  const channel = useSelector(selectCurrentChannel);
  const userIsGuest = useSelector(selectIsUserGuest);

  let displayCellId: JSX.Element | false = false;

  if (process.env.REACT_APP_MODE === 'development') {
    displayCellId = <div className={styles.displayCellId}>
      { cellId }
    </div>
  }

  return (
    <div className={styles.menu}>
      <CellMenuItem style={{color: (isFavorite ? "var(--cell-favorite-color)" : "inherit")}} cell_id={cellId} action={{
        name: isFavorite ? "remove_favorite" : "add_favorite",
        dispatch: true,
        action: doAddRemoveFavoriteCell(cellId, isFavorite ? "remove" : "add")
      }} disabled={userIsGuest}><BsStar /></CellMenuItem>
      <CellMenuItem cell_id={cellId} action={{
        name: "share",
        dispatch: false,
        action: (dispatch: Dispatch<any>) => {shareCell(dispatch, cellId, cellTitle, channel!.id)}
      }}><FiShare /></CellMenuItem>
      <CellMenuItem cell_id={cellId} action={{
        name: "recluster",
        dispatch: true,
        action: doChangeChannelRoute(channel!.id, {centroidId: cellId})
      }} disabled={disableRecluster}><ReclusterIcon height="1em" width="1em" /></CellMenuItem>

      { displayCellId }
    </div>
  )
}

function CellMenuItem(props: React.ButtonHTMLAttributes<HTMLButtonElement> & {action?: {name: string, dispatch: boolean, action: Function}, cell_id: number, disabled?: boolean}) {
  const dispatch = useDispatch();

  const dispatchAction = (e: React.MouseEvent | React.TouchEvent) => {
    if (typeof props.action !== "undefined" && props.disabled !== true) {
      // Dispatch or triger function
      if (props.action.dispatch) {
        dispatch(props.action.action);
      } else {
        props.action.action(dispatch);
      }

      // Firebase event
      firebase.analytics.logEvent("cell_menu", {action: props.action.name, cell_id: props.cell_id});
    }
  }

  return <ChannelButton<"button"> htmlElement="button" style={props.style} className={classnames(styles.menuButton, {[styles.menuButtonDisabled]: props.disabled})} onTap={dispatchAction}>{props.children}</ChannelButton>;
}

export default CellMenu;
